import {routeItems} from "@/router/endpoints";
import {permissions} from "@/router/permissions";

export const menuItems = [
    {
        id: 1,
        label: "menuitems.dashboard.text",
        icon: "bx-home-circle",
        link: "/dashboard"
    },
    {
        id: 7,
        isLayout: true
    },
    {
        id: 8,
        label: "menuitems.apps.text",
        isTitle: true
    },
    {
        id: 2,
        label: "menuitems.orders.text",
        icon: "bx-file",
        subItems: [
            {
                id: 3,
                label: "menuitems.orders.list.create_sample",
                link: routeItems.create_sample_order_route,
                permissions: permissions.create_sample_orders_permissions,
                parentId: 2
            },
            {
                id: 4,
                label: "menuitems.orders.list.sample_orders",
                link: routeItems.sample_orders_route,
                permissions: permissions.sample_orders_permissions,
                parentId: 2
            },
            {
                id: 5,
                label: "menuitems.orders.list.create_order",
                link: routeItems.create_order_route,
                permissions: permissions.create_orders_permissions,
                parentId: 2
            },
            {
                id: 6,
                label: "menuitems.orders.list.orders",
                link: routeItems.customer_orders_route,
                permissions: permissions.customer_orders_permissions,
                parentId: 2
            },
        ]
    },
    {
        id: 222,
        label: "menuitems.orders.deliveries",
        icon: "bx-car",
        subItems: [
            {
                id: 27,
                label: "menuitems.orders.list.scheduled_deliveries",
                link: routeItems.scheduled_deliveries_route,
                permissions: permissions.scheduled_deliveries_permissions,
                parentId: 222
            },
            {
                id: 275,
                label: "menuitems.orders.list.onroute_deliveries",
                link: routeItems.onroute_deliveries_route,
                permissions: permissions.onroute_deliveries_permissions,
                parentId: 222
            },
            {
                id: 28,
                label: "menuitems.orders.list.upcoming_deliveries",
                link: routeItems.upcoming_deliveries_route,
                permissions: permissions.upcoming_deliveries_permissions,
                parentId: 222
            },
            {
                id: 29,
                label: "menuitems.orders.list.incomplete_deliveries",
                link: routeItems.incomplete_deliveries_route,
                permissions: permissions.incomplete_deliveries_permissions,
                parentId: 222
            },
        ]
    },
    {
        id: 12,
        label: "menuitems.finance.text",
        icon: "bx-dollar-circle",
        subItems: [
            {
                id: 13,
                label: "menuitems.finance.list.pending",
                link: routeItems.pending_payments_route,
                permissions: permissions.pending_payments_permissions,
                parentId: 12
            },
            {
                id: 14,
                label: "menuitems.finance.list.processed",
                link: routeItems.processed_payments_route,
                permissions: permissions.processed_payments_permissions,
                parentId: 12
            },
            {
                id: 141,
                label: "menuitems.finance.list.credit_note",
                link: routeItems.credit_note_route,
                permissions: permissions.credit_note_permissions,
                parentId: 12
            },
            {
                id: 15,
                label: "menuitems.finance.list.manual",
                link: routeItems.manual_statements_route,
                permissions: permissions.manual_statements_permissions,
                parentId: 12
            },
            {
                id: 16,
                label: "menuitems.finance.list.automated",
                link: routeItems.automated_statements_route,
                permissions: permissions.automated_statements_permissions,
                parentId: 12
            },
        ]
    },
    {
        id: 22,
        label: "menuitems.stock.text",
        icon: "bx-buildings",
        subItems: [
            {
                id: 24,
                label: "menuitems.stock.list.all_warehouses",
                link: routeItems.warehouses_route,
                permissions: permissions.warehouses_permissions,
                parentId: 22
            },
            {
                id: 25,
                label: "menuitems.stock.list.record_shipment",
                link: routeItems.record_shipment_route,
                permissions: permissions.record_shipment_permissions,
                parentId: 22
            },
            {
                id: 26,
                label: "menuitems.stock.list.shipments",
                link: routeItems.shipments_route,
                permissions: permissions.shipments_permissions,
                parentId: 22
            },
        ]
    },
    {
        id: 21,
        label: "menuitems.stock.products",
        icon: "bx-package",
        subItems: [
            {
                id: 27,
                label: "menuitems.stock.list.add_product",
                link: routeItems.add_product_route,
                permissions: permissions.add_product_permissions,
                parentId: 21
            },
            {
                id: 28,
                label: "menuitems.stock.list.all_products",
                link: routeItems.products_route,
                permissions: permissions.products_permissions,
                parentId: 21
            },
            {
                id: 29,
                label: "menuitems.stock.list.stock",
                link: routeItems.stock_route,
                permissions: permissions.stock_permissions,
                parentId: 21
            },
            {
                id: 30,
                label: "menuitems.stock.list.adjust_stock",
                link: routeItems.adjusted_stock_route,
                permissions: permissions.adjusted_stock_permissions,
                parentId: 21
            },
        ]
    },
    {
        id: 32,
        label: "menuitems.customers.text",
        icon: "bx-user",
        subItems: [
            {
                id: 33,
                label: "menuitems.customers.list.create_sale_profile",
                link: routeItems.create_sales_profile_route,
                permissions: permissions.create_sales_profile_permissions,
                parentId: 32
            },
            {
                id: 34,
                label: "menuitems.customers.list.all_sale_profile",
                link: routeItems.sales_profile_route,
                permissions: permissions.sales_profile_permissions,
                parentId: 32
            },
            {
                id: 35,
                label: "menuitems.customers.list.add_customer",
                link: routeItems.add_customer_route,
                permissions: permissions.add_customer_permissions,
                parentId: 32
            },
            {
                id: 36,
                label: "menuitems.customers.list.all_customers",
                link: routeItems.all_customers_route,
                permissions: permissions.all_customers_permissions,
                parentId: 32
            },
        ]
    },
    {
        id: 42,
        label: "menuitems.reporting.text",
        icon: "bx-line-chart",
        subItems: [
            {
                id: 43,
                label: "menuitems.reporting.list.turnover",
                link: routeItems.turnover_reports_route,
                permissions: permissions.turnover_reports_permissions,
                parentId: 42
            },
            {
                id: 44,
                label: "menuitems.reporting.list.sales_activity",
                link: routeItems.sales_reports_route,
                permissions: permissions.sales_reports_permissions,
                parentId: 42
            },
            {
                id: 45,
                label: "menuitems.reporting.list.orders_and_deliveries",
                link: routeItems.orders_and_deliveries_reports_route,
                permissions: permissions.orders_and_deliveries_reports_permissions,
                parentId: 42
            },
            {
                id: 46,
                label: "menuitems.reporting.list.finance",
                link: routeItems.finance_reports_route,
                permissions: permissions.finance_reports_permissions,
                parentId: 42
            },
            {
                id: 47,
                label: "menuitems.reporting.list.stock",
                link: routeItems.stock_reports_route,
                permissions: permissions.stock_reports_permissions,
                parentId: 42
            },
            {
                id: 48,
                label: "menuitems.reporting.list.customers",
                link: routeItems.customers_reports_route,
                permissions: permissions.customers_reports_permissions,
                parentId: 42
            },
        ]
    },
    {
        id: 52,
        label: "menuitems.administration.text",
        icon: "bx-fingerprint",
        subItems: [
            // {
            //     id: 54,
            //     label: "menuitems.administration.list.all_user_roles",
            //     link: routeItems.user_roles_route,
            //     parentId: 52
            // },
            {
                id: 55,
                label: "menuitems.administration.list.add_system_user",
                link: routeItems.add_staff_route,
                permissions: permissions.add_staff_permissions,
                parentId: 52
            },
            {
                id: 56,
                label: "menuitems.administration.list.all_system_users",
                link: routeItems.staff_route,
                permissions: permissions.staff_permissions,
                parentId: 52
            },
            {
                id: 57,
                label: "menuitems.administration.list.automated_tasks",
                link: routeItems.automated_tasks_route,
                permissions: permissions.automated_tasks_permissions,
                parentId: 52
            },
            {
                id: 58,
                label: "menuitems.administration.list.user_settings",
                link: routeItems.user_settings_route,
                permissions: permissions.user_settings_permissions,
                parentId: 52
            },
            {
                id: 58,
                label: "menuitems.administration.list.system_settings",
                link: routeItems.system_settings_route,
                permissions: permissions.system_settings_permissions,
                parentId: 52
            },
        ]
    },

];
